<template>
  <section
    class="component-f0a51cd8"
    resmed-component-name="4card_graphic_line_text_link_4modal"
    v-bind:style="{ 'background-color': acf.layout['background-color'] }"
  >
    <div class="component">
      <div class="container px-xs-sm-2">
        <div class="row" v-if="acf.headline">
          <div class="col offset-md-1 offset-lg-2 offset-xl-0">
            <div class="title">
              <h5>{{ acf.headline }}</h5>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="items">
              <div class="item" v-for="(item, index) in items">
                <a
                  v-bind:href="item.cta.href"
                  v-bind:target="item.cta.target"
                  class="card"
                  v-on:mouseover="mouseover(index)"
                  v-on:click.prevent="overlay(item.modal)"
                >
                  <figure>
                    <img class="img-fluid" v-bind:src="item.svg" />
                  </figure>

                  <div class="content">
                    <div class="mb-3 content-body">
                      <h5 v-html="item.title"></h5>
                      <p v-html="item.description"></p>
                    </div>

                    <div class="call-to-action">
                      <a
                        v-bind:href="item.cta.href"
                        v-bind:target="item.cta.target"
                        class="btn cta-plain text-red icon right-arrow"
                        >{{ item.cta.text }}</a
                      >
                    </div>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <modal-f0a51cd8
      v-bind:content="modal.content"
      v-bind:active.sync="modal.active"
    ></modal-f0a51cd8>
  </section>
</template>

<script>
import modalF0a51cd8 from "../shared-support/modal-f0a51cd8";

export default {
  name: "component-f0a51cd8", // 4card_graphic_line_text_link_4modal
  props: ["acf"],
  components: {
    modalF0a51cd8,
  },
  data() {
    return {
      items: [],
      modal: {
        active: false,
        content: {},
      },
    };
  },
  methods: {
    mouseover(index) {
      for (let value of this.items) {
        value.play = false;
      }

      this.$nextTick(() => {
        this.items[index].play = true;
      });
    },
    // modal(...arg) {
    //     bus.$emit('modal:f0a51cd8', {
    //         active: true,
    //         content: 'content'
    //     });
    // },
    overlay(arg) {
      this.modal.active = true;
      this.modal.content = arg;
    },
  },
  created() {
    for (let value of this.acf.cards) {
      value.play = false; // add play property
    }

    this.items = Object.assign([], this.acf.cards);
  },
};
</script>

<style lang="scss" scoped>
@import "../../css/abstracts/path";
@import "../../css/abstracts/colors";
@import "../../css/base/typography";

.title {
  text-align: center;
  margin-bottom: 0.5rem;
  @extend %body-normal-bold;

  @media (min-width: 768px) {
    text-align: left;
  }

  h5 {
    position: relative;
    margin-bottom: 0.25rem;
    color: $cc-resmed-white;

    @extend %eyebrow-left;
    &:before {
      background-color: $cc-resmed-white;

      @media (max-width: 767px) {
        left: 50%;
        transform: translateX(-50%);
      }
    }

    @media (min-width: 768px) {
      margin-bottom: 0.75rem;
    }
  }
}

.component {
  padding: 4rem 0;
  transform: translateY(-10rem);
  margin-bottom: -10rem;

  .items {
    margin: 0 -0.625rem;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;

    .item {
      padding: 0.625rem;
      display: flex;

      @media (min-width: 768px) {
        width: calc(100% / 2);
        max-width: 302px;
      }

      @media (min-width: 992px) {
        max-width: 322px;
      }

      @media (min-width: 1200px) {
        width: calc(100% / 4);
      }

      h5 {
        position: relative;
        @extend %eyebrow-center;
      }

      .card {
        display: flex;
        flex-direction: column;
        color: inherit;

        background-color: $cc-resmed-white;
        box-shadow: 0 2rem 3rem 0 rgba(0, 0, 0, 0.125);
        border-radius: 6px;
        padding: 2rem 1rem 2.5rem 1rem;

        width: 100%;
        max-width: 360px;
        transition: all 0.5s;
        cursor: pointer;

        &:hover {
          background-color: $cc-resmed-bg-grey-2;
        }

        figure {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          margin-bottom: 2.25rem;

          .animation,
          .img-fluid {
            height: 224px;
            width: 100%;
            max-width: 224px;
          }

          .animation {
            display: flex;
            flex-direction: column;
            justify-content: center;
          }

          svg {
            width: 224px !important;
            height: 224px !important;
          }
        }

        .content {
          padding: 0 0.5rem;
          text-align: center;

          @media (min-width: 768px) {
            display: flex;
            flex-direction: column;
            flex: 1 0 auto;

            padding: 0 0.25rem 0 0.75rem;

            .content-body {
              flex: 1 0 auto;
            }
          }

          h5 {
            margin-bottom: 0.75rem;
            color: $cc-resmed-black;
          }
        }
      }
    }
  }
}
</style>